import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';

import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';
import type {
  RefundableRequestByResource,
  ResourceApproval,
} from '@/data/subsidy/interfaces';

interface CreateResourceApprovalResponse {
  resource_approval: { uuid: string };
}

export const useCreateResourceApproval = () => {
  const queryClient = useQueryClient();
  return useMutation<
    CreateResourceApprovalResponse,
    unknown,
    RefundableRequestByResource
  >({
    mutationFn: async (requestParams: RefundableRequestByResource) =>
      await falconClient.post(`${baseUrl}/resource_approvals`, {
        ...requestParams,
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: [clientKeys.useResourceApprovalsIndex],
      });
    },
  });
};

interface ResourceApprovalResponse {
  resource_approval: ResourceApproval;
}

export const useResourceApprovalShow = (
  id: string,
  refund_request_uuid: string
) => {
  const response = useQuery<ResourceApprovalResponse>({
    enabled: !!id,
    queryKey: [clientKeys.useResourceApprovalShow, id, refund_request_uuid],
    queryFn: async () => {
      return await falconClient.get(`${baseUrl}/resource_approvals/${id}`, {
        params: { ...(refund_request_uuid ? { refund_request_uuid } : {}) },
      });
    },
  });

  const resourceApproval = response?.data?.resource_approval || null;

  return { resourceApproval, ...response };
};
